import { render, staticRenderFns } from "./TableWrapper.vue?vue&type=template&id=70b4356c&"
import script from "./TableWrapper.vue?vue&type=script&lang=js&"
export * from "./TableWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/happoproperty.jp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b4356c')) {
      api.createRecord('70b4356c', component.options)
    } else {
      api.reload('70b4356c', component.options)
    }
    module.hot.accept("./TableWrapper.vue?vue&type=template&id=70b4356c&", function () {
      api.rerender('70b4356c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/TableWrapper.vue"
export default component.exports